import React, {Component} from 'react';
import {observer} from 'mobx-react';
import Card from '../edit-page/Card';
import renderField from '../edit-page/fields/FieldExtensions';
import CustomerStore from '../../store/customerStore'

const CustomerGeneralInformation = observer(
    class CustomerGeneralInformation extends Component {

        state = {
            editable: []
        }

        onButtonEditClick = field => {
            var newEditable = _.xor(this.state.editable, [field.slug]);
            CustomerStore.generalInformationDuringEdit = newEditable.length > 0;

            this.setState({
                editable: newEditable,
                changeEditIcon: !this.state.changeEditIcon
            })
        }

        renderField = (field, possibleToEdit) => {
            return renderField(field, this.state.editable.includes(field.slug), possibleToEdit, this.onButtonEditClick, '', () => {
            });
        }

        render() {
            let isEditable = CustomerStore.generalInformationDuringEdit;
            let model = CustomerStore.formModel.generalInformation;
            return (
                <Card
                    helpInfo={this.props.helpInfo}
                    label="General information"
                    // editableMode={true}
                    // editable={isEditable} 
                    onEditButtonClick={() => CustomerStore.generalInformationDuringEdit = !isEditable}>
                    <div className="row row-no-outer-gutter">
                        <div className="column-6 column-xs-12">
                            {this.renderField(model.fullName, true)}
                            {this.renderField(model.company, true)}
                            {this.renderField(model.responsible, false)}
                            {this.renderField(model.country, true)}
                        </div>
                        <div className="column-6 column-xs-12">
                            {this.renderField(model.address, true)}
                        </div>
                    </div>
                </Card>
            )
        }
    }
)

export default CustomerGeneralInformation;